import CMSApi from '../utils/opsloth_cms_service_api'
import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import { Box, Button, Chip, Dialog, DialogActions, DialogTitle, Fab, TextField } from '@mui/material'
import { Container } from '@mui/system'
import select_items from '../utils/select_items'

type Brands = {
  _id: string,
  brand: string
}

function Brands(props: any) {
  let brandTextField = ''
  const brandModal = new CMSApi('brands')
  const [brands, setBrands] = React.useState<Brands[]>([])
  const [addDialogOpen, setAddDialogOpen] = React.useState(false)
  const getBrands = async () => {
    const res = await select_items.loadBrands(true)
    setBrands(res as Brands[])
  }

  const handleOnTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    brandTextField = event.target.value
  }

  const handleAdd = async () => {
    const res: any = await brandModal.post({
      brand: brandTextField.toUpperCase()
    })
    if (res.data._id) {
      props.newAlert('创建品牌成功')
      setAddDialogOpen(false)
      getBrands()
    }
  }

  const handleOnBrandDelete = (_id: string) => async () => {
    const confirm = window.confirm('确认删除该品牌？')
    if (confirm) {
      await brandModal
        .setFilter({ _id: _id })
        .put({ deleted: true })
      getBrands()
    }
  }

  React.useEffect(() => {
    getBrands()
  }, [])

  return (
    <Box>
      {
        brands.map((item, index) => {
          return <Chip
            key={index}
            sx={{ m: .7, px: 1, fontSize: '1em' }}
            label={item.brand}
            size='medium'
            color='primary'
            onDelete={handleOnBrandDelete(item._id)}
          />
        }
        )
      }
      {
        <Fab
          sx={{ position: 'fixed', right: 20, bottom: 50 }}
          color='primary'
          size='medium'
          onClick={() => { setAddDialogOpen(true) }}
        >
          <AddIcon></AddIcon>
        </Fab >
      }
      <Dialog
        maxWidth='xl'
        open={addDialogOpen}
        onClose={() => { setAddDialogOpen(false); brandTextField = '' }}
      >
        <Container
          maxWidth='xl'
        >
          <DialogTitle>添加品牌</DialogTitle>
          <TextField
            onChange={handleOnTextFieldChange}
            sx={{ width: '30em' }}
          ></TextField>
        </Container>
        <DialogActions>
          <Button
            sx={{ m: 1 }}
            onClick={() => setAddDialogOpen(false)}
          >
            {"取消"}
          </Button>

          <Button
            onClick={handleAdd}
          >
            {"提交"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}



export default Brands